// this file for show popup on full body, now this using in faceRegister component

import { createPortal } from "react-dom";

const Portal = ({ children }) => {
  return createPortal(children, document.body);
};

export default Portal;
